module.exports = __webpack_public_path__ + "static/media/stars-in-the-night-sky.6a7f6126.jpg";